import lazyLoading from './lazyLoading';

export default {
  name: 'Options',
  path: '/options',
  component: lazyLoading('options/OptionsForm'),
  meta: {
    title: 'schema.options',
    iconClass: 'fa fa-cog',
    to: '/options',
    auth: 'admin',
  },
  props: r => ({root: true}),
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/options.js